import React from "react";

export const PageNotFound: React.FC = () => {
  return <h1>404 - Page Not Found</h1>;
};
